// Thin wrapper around gtag so we get type safety and a single
// place to disable tracking in development.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const isDev = import.meta.env.DEV;

function track(eventName: string, params?: Record<string, unknown>) {
  if (isDev) return; // don't pollute GA data in dev
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

export const analytics = {
  /** User loaded and started the test */
  testStarted() {
    track('test_started');
  },

  /** User completed and submitted the test */
  testCompleted(typeNumber: number, wing?: number | null) {
    track('test_completed', {
      enneagram_type: typeNumber,
      enneagram_wing: wing ?? null,
    });
  },

  /** User submitted email capture on results page */
  emailCaptured(typeNumber: number) {
    track('email_captured', {
      enneagram_type: typeNumber,
    });
  },

  /** User clicked "Challenge a friend" copy/share */
  challengeShared(method: 'copy' | 'sms' | 'twitter') {
    track('challenge_shared', { method });
  },

  /** User navigated to a type page */
  typePageViewed(typeNumber: number) {
    track('type_page_viewed', { enneagram_type: typeNumber });
  },

  /** User navigated to a wing page */
  wingPageViewed(typeNumber: number, wingNumber: number) {
    track('wing_page_viewed', {
      enneagram_type: typeNumber,
      enneagram_wing: wingNumber,
    });
  },
};
